import { Box, Chip, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import type { Ticket } from '../api';
import { STATUS_COLOUR } from './status';

export function TableView({
  tickets,
  onOpen,
}: {
  tickets: Ticket[];
  onOpen: (ref: number) => void;
}) {
  if (tickets.length === 0) {
    return (
      <Typography sx={{ p: 3 }} color="text.secondary">
        Nothing matches this filter.
      </Typography>
    );
  }

  return (
    // The board is wide; scroll the table rather than the page body.
    <Box sx={{ overflowX: 'auto' }}>
      <Table size="small" stickyHeader>
        <TableHead>
          <TableRow>
            {['Ref', 'Name', 'Status', 'Epic', 'Priority', 'Sequencing', 'Effort'].map((head) => (
              <TableCell key={head} sx={{ whiteSpace: 'nowrap', fontWeight: 600 }}>
                {head}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {tickets.map((ticket) => (
            <TableRow
              key={ticket.ref}
              hover
              onClick={() => onOpen(ticket.ref)}
              sx={{ cursor: 'pointer', opacity: ticket.archived ? 0.5 : 1 }}
            >
              <TableCell sx={{ fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap' }}>
                DWLF-{ticket.ref}
              </TableCell>
              <TableCell sx={{ minWidth: 280 }}>{ticket.name}</TableCell>
              <TableCell>
                <Chip size="small" label={ticket.status} color={STATUS_COLOUR[ticket.status] ?? 'default'} />
              </TableCell>
              <TableCell sx={{ whiteSpace: 'nowrap' }}>{ticket.epic}</TableCell>
              <TableCell sx={{ whiteSpace: 'nowrap' }}>{ticket.planPriority}</TableCell>
              <TableCell sx={{ whiteSpace: 'nowrap' }}>{ticket.sequencing}</TableCell>
              <TableCell sx={{ whiteSpace: 'nowrap' }}>{ticket.effort}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
}
